// extracted by mini-css-extract-plugin
export var grid = "_2l-0";
export var span1 = "_2l-2";
export var span10 = "_2l-b";
export var span10L = "_2l-z";
export var span10M = "_2l-n";
export var span10Xl = "_2l-1b";
export var span11 = "_2l-c";
export var span11L = "_2l-10";
export var span11M = "_2l-o";
export var span11Xl = "_2l-1c";
export var span12 = "_2l-d";
export var span12L = "_2l-11";
export var span12M = "_2l-p";
export var span12Xl = "_2l-1d";
export var span1L = "_2l-q";
export var span1M = "_2l-e";
export var span1Xl = "_2l-12";
export var span2 = "_2l-3";
export var span2L = "_2l-r";
export var span2M = "_2l-f";
export var span2Xl = "_2l-13";
export var span3 = "_2l-4";
export var span3L = "_2l-s";
export var span3M = "_2l-g";
export var span3Xl = "_2l-14";
export var span4 = "_2l-5";
export var span4L = "_2l-t";
export var span4M = "_2l-h";
export var span4Xl = "_2l-15";
export var span5 = "_2l-6";
export var span5L = "_2l-u";
export var span5M = "_2l-i";
export var span5Xl = "_2l-16";
export var span6 = "_2l-7";
export var span6L = "_2l-v";
export var span6M = "_2l-j";
export var span6Xl = "_2l-17";
export var span7 = "_2l-8";
export var span7L = "_2l-w";
export var span7M = "_2l-k";
export var span7Xl = "_2l-18";
export var span8 = "_2l-9";
export var span8L = "_2l-x";
export var span8M = "_2l-l";
export var span8Xl = "_2l-19";
export var span9 = "_2l-a";
export var span9L = "_2l-y";
export var span9M = "_2l-m";
export var span9Xl = "_2l-1a";
export var stretch = "_2l-1";